import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';

const RulesList = async () =>
    import('../../pages/automations/IncidentAutoCreate/RulesList').then((module) => ({
        Component: module.RulesList,
    }));
const NewRule = async () =>
    import('../../pages/automations/IncidentAutoCreate/NewRule').then((module) => ({
        Component: module.NewRule,
    }));
const EditRule = async () =>
    import('../../pages/automations/IncidentAutoCreate/EditRule').then((module) => ({
        Component: module.EditRule,
    }));
const Runs = async () =>
    import('../../pages/automations/IncidentAutoCreate/RunsList').then((module) => ({
        Component: module.RunsList,
    }));

const getIncidentAutoCreateRoutes = (user) => {
    return [
        {
            path: '/automations/incident-auto-create/',
            lazy: RulesList,
        },
        {
            path: '/automations/incident-auto-create/new-rule',
            lazy: NewRule,
            condition: Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/incident-auto-create/',
        },
        {
            path: '/automations/incident-auto-create/:ruleId',
            element: <NavigateWithParams to={(params) => `/automations/incident-auto-create/${params.ruleId}/edit`} />,
        },
        {
            path: '/automations/incident-auto-create/:ruleId/edit',
            lazy: EditRule,
            condition: Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/incident-auto-create/',
        },
        {
            path: '/automations/incident-auto-create/runs',
            lazy: Runs,
        },
    ];
};

export { getIncidentAutoCreateRoutes };
